<template>
  <div class="arrivalManagePage" v-if="!showLoad">
    <div v-for="item in propertyData" :key="item.id">
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="item.contractName"
          readonly
          type="textarea"
          row="1"
          class="ggInput"
          input-align="right"
          label="所属合同："
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary dwBox">
        <van-field
          v-model="item.amount"
          readonly
          clearable
          class="ggInput"
          input-align="right"
          label="开票金额（元）："
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="item.typeName"
          readonly
          clearable
          class="ggInput"
          input-align="right"
          label="发票类型："
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="item.oppositeTallage"
          readonly
          clearable
          class="ggInput"
          input-align="right"
          label="对方税号："
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary dwBox">
        <van-field
          v-model="item.oppositeCompany"
          readonly
          clearable
          class="ggInput"
          input-align="right"
          label="对方单位名称："
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary" v-if="item.reason!=''">
        <van-field
          v-model="item.reason"
          readonly
          type="textarea"
          row="1"
          class="ggInput"
          input-align="right"
          label="开票原因："
        />
      </van-cell-group>
    </div>

    <div class="claimDetailLists" v-if="invoiceData[0]">
      <h4 class="title">到账详情</h4>
      <ul>
        <li class="listLi dis_flex justy_space" v-for="item in invoiceData" :key="item.id">
          <div class="liLeft">
            <p class="nick">办理人：{{item.realName}}</p>
            <span class="money">金额（元）：{{item.amount}}</span>
          </div>
          <div class="liRight time">申请时间：{{item.createTime}}</div>
        </li>
      </ul>
    </div>
    <refresh-page v-if="refreshPage" />
  </div>
</template>
<script>
/*eslint-disable*/
import newApi from "lodash";
 
import { mapMutations ,mapState} from "vuex";
import { dateFormat } from "@/utils/common";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "arrivalManage",
  data() {
    return {
      commonId: "", //点击过来的id
      propertyData: [
        //累计金额等信息
        {
          contractName: "", // 所属合同名称
          amount: "", // 申请开票金额
          type: "", // 发票类型
          oppositeTallage: "", // 对方单位税号
          oppositeCompany: "", // 对方单位名称
          reason: "" //开票原因
        }
      ],
      refreshPage: false, // 网络请求失败时显示
      invoiceData: [], //开票数组
      clientType: getDeviceType() //手机类型
    };
  },
  mounted() {
    window.getKpIds = this.getKpIds;
    this.commonId = this.$route.query.commonId; //申请Id
    this.mode = this.$route.query.postType; // add:新增 edit:查看/编辑
    window.editPage = this.editPage; //编辑页面
    window.setFile = this.setFiles; //app返回附件回调
    this.initPage();
  },
  methods: {
    ...mapMutations(["setShowLoad"]),
    //查看累计金额等信息
    initPage() {
      if (this.clientType == "android") {
        window.android.getInfo(107);
      } else {
        window.webkit.messageHandlers.getKpIds.postMessage(null);
      }
      this.inDetail();
    },
    getKpIds(data) {
      let ids = "";
      if (this.clientType == "android") {
        ids = data;
      } else {
        ids = JSON.parse(data);
      }
       
      this.detailFuction(ids);
    },
    detailFuction(ids) {
      let _this = this;
      _this.$api.finance.account
        .getListByInvoiceId(ids)
        .then(res => {
          _this.setShowLoad(false);
          if (res.code == "1") {
            _this.propertyData = res.data;
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch(err => {
          _this.$toast("网络失败，请稍后重试");
        });
    },
    inDetail() {
      let _this = this;
      _this.$api.finance.account
        .viewDetail({ relationId: _this.commonId, accountType: "fp" })
        .then(res => {
          _this.setShowLoad(false);
          if (res.code == "1") {
            _this.invoiceData = newApi.assign({}, _this.invoiceData, res.data);
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch(err => {
          _this.$toast("网络失败，请稍后重试");
        });
    }
  },
   computed: {
    ...mapState(["showLoad", "userinfo"])
  },
};
</script>
<style lang="less">
.arrivalManagePage {
  width: 100%;
  height: 100%;
  background-color: #fff;
  .time {
    color: #999;
    font-size: 10px;
  }
  .money {
    color: #2581d6;
    font-size: 13px;
  }
  .nick {
    font-size: 14px;
    padding-bottom: 4px;
  }
  .listLi {
    align-items: flex-end;
    padding-bottom: 10px;
    border-bottom: 1px solid #f1f1f1;
  }
  .btnBox {
    width: 100%;
    padding: 10px 14px;
    // height: 45px;
    position: fixed;
    background: #fff;
    left: 0;
    bottom: 0px;
    button {
      width: 100%;
    }
  }
  .claimDetailLists {
    margin: 0 10px 80px;
    padding: 0 10px;
    .title {
      font-size: 13px;
      line-height: 40px;
      // text-align: center;
      color: #2581d6;
      position: relative;
      padding-left: 10px;
    }
    .title:before {
      content: "";
      position: absolute;
      width: 4px;
      height: 15px;
      background: #2581d6;
      top: 13px;
      left: 0px;
      bottom: 5px;
    }
  }
  .dwBox {
    .van-cell {
      .van-cell__title {
        width: 150px;
      }
    }
  }
}
</style>